var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDatePickerIcon = function SvgDatePickerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.4V7H4.9V8.4H3.5Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 8.4H7.7V7H6.3V8.4Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 8.4V7H10.5V8.4H9.1Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.8V11.2H4.9V9.8H3.5Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 11.2H6.3V9.8H7.7V11.2Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 0.7H4.2V0H2.8V0.7H1.4C0.626801 0.7 0 1.3268 0 2.1V12.6C0 13.3732 0.626801 14 1.4 14H12.6C13.3732 14 14 13.3732 14 12.6V2.1C14 1.3268 13.3732 0.7 12.6 0.7H11.2V0H9.8V0.7ZM4.2 2.8H2.8V2.1H1.4V4.2H12.6V2.1H11.2V2.8H9.8V2.1H4.2V2.8ZM12.6 5.6H1.4V12.6H12.6V5.6Z",
    fill: "#828282"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatePickerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DatePickerIcon.8dcd71cf.svg";
export { ForwardRef as ReactComponent };